export function formatPostedOnChannels(value: {channel: string, value: boolean}[]): { includeChannels: string, excludeChannels: string } {
    if (value === undefined || value === null || !Array.isArray(value) || value.length === 0) {
        return { includeChannels: '', excludeChannels: '' };
    }
    
    const includeChannelsArr: String[] = [];
    const excludeChannelsArr: String[] = [];
    value.forEach(postedOnChannel => {
        if (postedOnChannel.value) {
            includeChannelsArr.push(postedOnChannel.channel);
        } else {
            excludeChannelsArr.push(postedOnChannel.channel);
        }
    });

    return { 
        includeChannels: includeChannelsArr.join('$$'), 
        excludeChannels: excludeChannelsArr.join('$$')
    };
}

export default formatPostedOnChannels;
